import { HTMLInputTypeAttribute, useState } from 'react'
import { RegisterOptions, useFormContext } from 'react-hook-form'

import InputLabel from '@atoms/InputLabel'
import EyeIcon from '@icons/Eye'

import * as style from './style.module.sass'

type TextInputProps = {
  name: string
  label?: string
  registerOptions?: RegisterOptions
  type?: HTMLInputTypeAttribute
  placeholder?: string
  note?: string
  errorMessage?: string
  className?: string
  design?: 'default' | 'large' | 'code' | 'gray'
  disabled?: boolean
}
const TextInput = ({
  name,
  label,
  registerOptions = {},
  type,
  placeholder,
  note,
  errorMessage,
  className,
  design = 'default',
  disabled = false,
}: TextInputProps) => {
  const { register } = useFormContext()
  const [showPassword, setShowPassword] = useState(false)

  return (
    <label className={`${style.textInput} ${className}`} data-design={design}>
      {label !== undefined && (
        <InputLabel
          label={label}
          required={registerOptions.required === true}
          design={design}
        />
      )}
      <input
        type={showPassword ? 'text' : type}
        placeholder={placeholder}
        {...register(name, registerOptions)}
        data-error={errorMessage !== undefined}
        data-type={type}
        disabled={disabled}
      />
      {note !== undefined && <div className={style.note}>{note}</div>}
      {errorMessage !== undefined && (
        <div className={style.errorMessage}>{errorMessage}</div>
      )}
      {type === 'password' && (
        <button
          className={style.eye}
          type="button"
          onClick={() => setShowPassword(!showPassword)}
        >
          <EyeIcon active={showPassword} />
        </button>
      )}
    </label>
  )
}

export default TextInput
